angular.module('aprima-legacy-common').run(['CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(
    ['$rootScope', 'TransitionManager', 'AprimaAnalytics', 'DeviceSettings', '_', 'toaster',
        function ($rootScope, TransitionManager, AprimaAnalytics, DeviceSettings, _, toaster) {

            $rootScope.goBack = function () {
                TransitionManager.goBack();
                AprimaAnalytics.sendEvent('user', 'click', 'back button');
            };

            $rootScope.isEmpty = function (obj) {
                return _.isEmpty(obj);
            };

            $rootScope.isPhone = DeviceSettings.isPhoneOrOverride;
            $rootScope.isTablet = DeviceSettings.isTabletOrOverride;
            $rootScope.isBrowser = DeviceSettings.isBrowserOrOverride;

            $rootScope.tryToastModelStateError = function tryToastModelStateError(response) {
                var modelState = response.ModelState || (response.data && response.data.ModelState);

                if(modelState && modelState.commandResult) {
                    _(modelState.commandResult).forEach(function(e){
                        toaster.pop('error', '', e);
                    });
                }
            };
        }]);
}]);
